import { color } from '@amcharts/amcharts4/core';

export const colors = [
	'#9031AA',
	'#EB457B',
	'#F09551',
	'#FCEC60',
	'#C5D95A',
	'#94C459',
	'#67AD5B',
	'#50B39C',
	'#6AC6E7',
	'#4BA6EE',
	'#9D86E7',
	'#DF5AA1',
	'#E15241',
	'#C12F9A',
	'#F5C04E',
].map((c) => color(c));
